import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Error from "./views/Error.vue";
import store from "@/store";
import jwt from "jsonwebtoken";
import CustomerService from "@/services/customer-service/customer-service";
const secret =
  "JwtSuperSecretStringKeyJwtSuperSecretStringKeyJwtSuperSecretStringKeyJwtSuperSecretStringKey";
Vue.use(Router);
const router = new Router({
  routes: [
    {
      path: "/home/:token",
      name: "home",
      component: Home,
      beforeEnter: (to, from, next) => {
        const token = to.params.token;
        if (token.length < 10) {
          redirectToError();
        }
        const { sapcode } = jwt.verify(token, secret);
        if (sapcode) {
          redirectToHome(sapcode, next);
        } else {
          redirectToError();
        }
      }
    },
    {
      path: "/error",
      name: "error",
      component: Error
    },
    {
      path: "*",
      name: "default",
      component: Error
    }
  ]
});
const redirectToHome = (sapcode, next) => {
  CustomerService.getCustomer(sapcode)
    .then(({ data }) => {
      store.dispatch("storeCustomerData", data);
      next();
    })
    .catch(err => {
      redirectToError();
    });
};
const redirectToError = () => {
  router.push("/error");
};
export default router;